/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { Col, message, Modal, Row, Typography } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { axiosErp } from 'shared/config/axios';
import { getStoredAuthToken } from 'shared/utils/authToken';
import { Button, Spin } from 'shared/components';
import { FileContainer } from './Styles';

const { confirm } = Modal;
const { Text } = Typography;

type DocumentListProps = {
  costingId: string;
  dataCosting: any;
};

const DocumentList: React.FC<DocumentListProps> = (props) => {
  const { costingId, dataCosting } = props;
  const token = getStoredAuthToken();
  const [loading, setLoading] = useState(false);
  const [data, setDataCosting] = useState<any>(null);

  const functionGetData = async () => {
    setLoading(true);
    try {
      const costingData = await axiosErp(token).post(`/costing-document-job-list`, {
        params: {
          delete: false,
          costingJobId: costingId,
        },
      });
      setDataCosting(costingData.data);
      setLoading(false);
    } catch (e) {
      message.error(e.message);
      console.error('ERROR TO LOAD COSTING DETAIL: ', e);
    } finally {
      setLoading(false);
    }
  };

  const functionDeleteDocument = async (_id: string) => {
    setLoading(true);
    try {
      await axiosErp(token).post(`/delete-costing-document-job`, {
        _id: [_id],
      });
      setLoading(false);
    } catch (err) {
      message.error(err.message);
    } finally {
      message.success('ลบไฟล์เอกสารแล้ว');
      functionGetData();
    }
  };

  const showConfirmDeleteDocument = (id: string) => {
    const modal = {
      title: 'ยืนยัน',
      icon: <ExclamationCircleOutlined />,
      content: (
        <>
          ต้องการ <Text strong>ลบไฟล์เอกสาร</Text> ใช่หรือไม่?
        </>
      ),
      okText: 'ตกลง',
      onOk() {
        functionDeleteDocument(id);
      },
      cancelText: 'ยกเลิก',
    };

    confirm(modal);
  };

  let documentList = null;
  if (data || dataCosting) {
    const { documents } = dataCosting || data;
    documentList = documents.map((item) => (
      <Col key={item._id} span={24}>
        <FileContainer>
          <Button
            onClick={() => showConfirmDeleteDocument(item._id)}
            icon={<DeleteOutlined />}
            color="red--outline"
            style={{ marginRight: 10 }}
          />
          <a href={item.documentFile} target="_blank" rel="noopener noreferrer">
            {item.documentFile}
          </a>
        </FileContainer>
      </Col>
    ));
  }

  useEffect(() => {
    if (costingId) {
      functionGetData();
    }
  }, [costingId]);

  return (
    <Spin spinning={loading}>
      <Row gutter={[16, 16]}>{documentList}</Row>
    </Spin>
  );
};

export default DocumentList;
